module.exports = __webpack_public_path__ + "static/media/portfolio-bottom.0cc28002.png";